import { componentClasses } from "../../../core/components/date-picker/calendar";
import { chevronLeft, chevronRight } from "../../../core/js/helpers/built-in-icons";

const calendarTemplate = () => {
    return `<div class="${componentClasses.calendar.base}"></div>`;
};

// Internal Functions

const calendarHeaderTemplate = () => {
    return `
        <div class="${componentClasses.header}">
            <div class="${componentClasses.headerDisplay}">
                <select class="${componentClasses.monthSelect}"></select>
                <select class="${componentClasses.yearSelect}"></select>
                <div class="${componentClasses.headerPolite} dds__sr-only" aria-live="polite"></div>
            </div>
            <div>
                <button type="button" class="${
                    componentClasses.prevButton
                } dds__button dds__button--sm dds__button--tertiary dds__button__icon">
                    ${chevronLeft()}
                </button>
                <button type="button" class="${
                    componentClasses.nextButton
                } dds__button dds__button--sm dds__button--tertiary dds__button__icon">
                    ${chevronRight()}
                </button>
            </div>
        </div>
    `;
};

const calendarBodyTemplate = () => {
    return `<div class="${componentClasses.body}" role="grid">
        <div class="${componentClasses.grid.head}" role="rowgroup">
            <div class="${componentClasses.grid.row}" role="row"></div>
        </div>
        <div class="${componentClasses.grid.body}" role="rowgroup">
            <div class="${componentClasses.grid.row}" role="row"></div>
            <div class="${componentClasses.grid.row}" role="row"></div>
            <div class="${componentClasses.grid.row}" role="row"></div>
            <div class="${componentClasses.grid.row}" role="row"></div>
            <div class="${componentClasses.grid.row}" role="row"></div>
            <div class="${componentClasses.grid.row}" role="row"></div>
        </div>
    </div>`;
};

const calendarFooterTemplate = () => {
    return `
        <div class="${componentClasses.footer}">
            <button type="button" class="${componentClasses.today} dds__button dds__button--sm dds__button--tertiary">
            </button>
            <button type="button" class="${componentClasses.cancel} dds__button dds__button--sm dds__button--secondary">
            </button>
            <button type="button" class="${componentClasses.confirm} dds__button dds__button--sm">
            </button>
        </div>
    `;
};

export { calendarTemplate, calendarHeaderTemplate, calendarBodyTemplate, calendarFooterTemplate };
